import styled from 'styled-components';
import { gridColumn, gridRow } from 'styleUtils/grid';

export const AvatarWrapper = styled.div`
    ${gridColumn({ start: 1 })}
    ${gridRow({ start: 1 })}
    align-items: center;
`;
